import api from '../base/ControllerUtil'

const controller = 'ImportacaoUsuario'
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({
  Importar: (data) => api.Axios.Post(url, data)
}, api.GetCrud(controller, null), {});
